<template>
  <div>
    <div class="d-flex justify-content-between button-group">
      <div class="d-flex justify-content-left button-group">
        <b-button v-if="!isNewRequest" @click="openHistoryModal">{{$t('buttons.common.history')}}</b-button>
        <history-modal-content></history-modal-content>
        <b-button v-if="!isNewRequest" @click="openPrintModal" class="margin">{{$t('buttons.common.print')}}</b-button>
        <print-document-modal
        ></print-document-modal>
        <request-item-create-modal
          :delivery_term="this.RO_delivery_term"
          :requestID="this.param">
        </request-item-create-modal>
      </div>
      <div>
        <b-button v-if="currentRoutePermissions.change_requestorder" class="btn" variant="secondary" @click="save"
                  size="sm">
          {{$t('buttons.common.save')}}
        </b-button>
      </div>
    </div>
    <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
         :aria-expanded="showCollapse ? 'true' : 'false'"
         aria-controls="collapse">
      <h3>
        {{requestLabel}}
      </h3>
      <div class="icons-wrapper">
        {{requestInfo}}
        <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
        <icon name="angle-right" class="angle" v-else></icon>
      </div>
    </div>
    <b-collapse id="collapse" v-model="showCollapse">
      <div class="search-form">
        <div class="search-form__filters">
          <b-row>
            <b-col>
              <label>{{$t('labels.common.seller')}}</label>
              <multiselect v-model="requestData.seller" :max-height="200"
                           placeholder="Choose seller" label="name" track-by="name"
                           :options="sellers"
                           :class="{ required: (!requestData.seller) }"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.contracts.contract_number')}}</label>
              <multiselect v-model="requestData.contracts" :max-height="200"
                           placeholder="" label="contract_nr" track-by="id" :multiple="true"
                           :options="[]" :disabled="true"></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.measure_type')}}</label>
              <multiselect v-model="requestData.measuries" :max-height="200"
                           placeholder="" :multiple="true"
                           :options="[]" :disabled="true"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.common.supplier')}}</label>
              <multiselect v-model="requestData.shipper" :max-height="200"
                           placeholder="Choose supplier" label="name" track-by="id"
                           :options="suppliers"
                           :class="{ required: (!requestData.shipper) }"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.delivery_term')}}</label>
              <multiselect v-model="requestData.incoterms" :max-height="200"
                           placeholder="Choose delivery term" label="code" track-by="id"
                           :options="incoterms"
                           :show-labels="false"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.currency')}}</label>
              <multiselect v-model="requestData.currencies" :max-height="200"
                           placeholder="" :multiple="true"
                           :options="[]" :disabled="true"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.common.buyer')}}</label>
              <multiselect v-model="requestData.buyer" :max-height="200"
                           placeholder="Choose buyer" label="name" track-by="name"
                           :options="customers"
                           :class="{ required: (!requestData.buyer) }"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.transport')}}</label>
              <multiselect v-model="requestData.delivery_method" :max-height="200"
                           placeholder="Choose transport" label="name" track-by="id"
                           :options="delivery_methods"
                           :taggable="true" :close-on-select="true"></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.notes')}}</label>
              <b-form-textarea v-model="requestData.notes" placeholder="Enter notes">
              </b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <label>{{$t('labels.common.delivery_date')}}</label>
              <datepicker v-model="requestData.delivery_term" lang="en" :first-day-of-week="1"
                          :class="{ required: (!requestData.delivery_term) }"
              ></datepicker>
            </b-col>
            <b-col cols="4">
              <label>{{$t('labels.requests.request_order_date')}}</label>
              <datepicker v-model="requestData.request_order_date" lang="en" :first-day-of-week="1"
                          :class="{ required: (!requestData.request_order_date) }"
              ></datepicker>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-collapse>
    <b-card no-body v-if="!isNewRequest">
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <portal-target name="request_items"></portal-target>
          </template>
          <portal to="request_items">
            {{$t('tabs.requests.request_items')}}
          </portal>
          <div class="d-flex justify-content-between button-group">
            <div>
              {{$t('labels.common.selected')}}: {{selectedRowsCount}}
              <b-button v-if="currentRoutePermissions.change_requestorder" class="btn" @click="deleteRequestItem"
                        variant="danger" size="sm">
                {{$t('buttons.requests.delete_request_item')}}
              </b-button>
            </div>
            <b-button v-if="currentRoutePermissions.change_requestorder" class="btn" variant="success"
                      @click="openRequestItemModal" size="sm">
              {{$t('buttons.requests.create_request_item')}}
            </b-button>
          </div>
          <ag-grid-vue class="ag-theme-balham"
                       :rowData="requestItems"
                       :style="gridHeight"
                       :columnDefs="requestItemsColumns"
                       :gridOptions="requestItemsGridOptions" :pinnedBottomRowData="requestItemsPinnedRowData"
                       @rowSelected="countSelectedRows" @rowDataChanged="countSelectedRows"
                       @rowDoubleClicked="openRequestItemModal">
          </ag-grid-vue>
        </b-tab>
        <b-tab>
          <template slot="title">
            <portal-target name="docs"></portal-target>
          </template>
          <portal to="docs">
            {{$t('tabs.common.documents')}}
          </portal>
          <app-documents :documents="documents" :isCollapse="showCollapse" :url="commonUrl + 'attachments/'"
                         @loadDocuments="loadDocuments"></app-documents>
        </b-tab>
        <b-tab>
          <template slot="title">
            <portal-target name="comment"></portal-target>
          </template>
          <portal to="comment">
            {{$t('tabs.common.comments')}}
          </portal>
          <app-comments :comments="comments" :url="commonUrl + 'comments/'"
                        @loadComments="loadComments"></app-comments>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import RangeDatePicker from 'vue2-datepicker';
  import moment from 'moment';
  import RequestItemCreateModal from '@/components/modals/PurchaseRequestItemModal';
  import HistoryModalContent from '@/components/modals/HistoryModal';
  import PrintDocumentModal from '@/components/modals/PrintDocumentModal.vue';
  import Documents from '@/components/common/Documents';
  import Comments from '@/components/common/Comments';
  import {
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';

  export default {
    components: {
      Multiselect,
      RangeDatePicker,
      'ag-grid-vue':
      AgGridVue,
      Datepicker,
      RequestItemCreateModal,
      PrintDocumentModal,
      HistoryModalContent,
      'app-documents': Documents,
      'app-comments': Comments
    },
    data() {
      return {
        showCollapse: true,
        selectedRowsCount: 0,
        requestData: {
          request_order_nr: '',
          delivery_term: '',
          delivery_method: '',
          measuries: 'm3',
          shipper: '',
          contracts: '',
          currency: '',
          seller: '',
          notes: '',
          buyer: '',
          request_order_date: ''
        }
      }
    },
    methods: {
      save() {
        const saveData = {
          notes: this.requestData.notes,
          delivery_term: this.requestData.delivery_term ? moment(this.requestData.delivery_term).format(DATE_FORMAT) : '',
          request_order_date: this.requestData.request_order_date ? moment(this.requestData.request_order_date).format(DATE_FORMAT) : '',
          seller: this.requestData.seller ? this.requestData.seller.id : '',
          buyer: this.requestData.buyer ? this.requestData.buyer.id : '',
          shipper: this.requestData.shipper ? this.requestData.shipper.id : '',
          incoterms: this.requestData.incoterms ? this.requestData.incoterms.id : '',
          delivery_method: this.requestData.delivery_method ? this.requestData.delivery_method.id : '',
        };
        if (this.isNewRequest) {
          this.$http.post(`purchase/request_orders/`, saveData)
            .then(handlerResponse).then((response) => {
            this.requestData = {...response};
            this.$notify(setNotifyData('Success', 'Request has been created!', 'success'));
            this.getRequestinfo(response.id);
            this.$router.push({path: `/requests/${response.id}`});
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$http.put(`purchase/request_orders/${this.param}/`, saveData).then(handlerResponse).then(() => {
            this.getRequestinfo(this.param);
            this.$notify(setNotifyData('Success', 'Request has been saved!', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        }
      },
      openRequestItemModal(params) {
        if (this.currentRoutePermissions.change_requestorder) {
          if (params.data) {
            this.$http.get(`purchase/request_items/${params.data.id}/`).then(handlerResponse).then((response) => {
              this.$root.$emit('openCreateRequestItemModal', {...response, isNewItem: false});
            });
          } else {
            this.$root.$emit('openCreateRequestItemModal');
          }
        }
      },
      deleteRequestItem() {
        const id = getArrayByProperty(this.requestItemsGridOptions.api.getSelectedRows(), 'id');
        if (id.length) {
          this.$http.delete(`purchase/request_items/`, {body: {id}}).then(() => {
            this.getRequestinfo(this.param);
            this.$store.dispatch('requests/loadRequestItems', {request_order_id: this.param});
            this.$notify(setNotifyData('Success', 'Request item has been removed!', 'success'));
          }).catch((error) => {
            notificationsRenderer(error.body, 'error');
          });
        } else {
          this.$notify(setNotifyData('Select request item for removing', '', 'warn'));
        }
      },
      getRequestinfo(id) {
        this.$http.get(`purchase/request_orders/${id}/`).then(handlerResponse).then((response) => {
          this.requestData = response;
          this.$store.dispatch('requests/loadRequestItems', {request_order_id: this.param});
          this.$store.dispatch('location/setPathName', response.request_order_nr);
        }).catch(() => {
          this.$router.push({path: `/requests/new`});
          this.$notify(setNotifyData('', 'Request with such ID has been not found. You can create new one', 'error'));
        });
      },
      countSelectedRows() {
        this.selectedRowsCount = getArrayByProperty(this.requestItemsGridOptions.api.getSelectedRows(), 'id') ? getArrayByProperty(this.requestItemsGridOptions.api.getSelectedRows(), 'id').length : 0
      },
      loadComments(cacheFlag) {
        if (cacheFlag) {
          this.$store.dispatch('requests/loadCommentsList', {id: this.param});
        } else {
          this.$store.dispatch('requests/loadCommentsList', {id: this.param});
        }
      },
      loadDocuments(cacheFlag) {
        if (cacheFlag) {
          this.$store.dispatch('requests/loadDocumentsList', {id: this.param});
        } else {
          this.$store.dispatch('requests/loadDocumentsList', {id: this.param});
        }
      },
      clearData() {
        this.$store.cache.delete('requests/loadDocumentsList', {id: this.param});
        this.$store.cache.delete('requests/loadCommentsList', {id: this.param});
        if (this.comments.length) {
          this.$store.commit('requests/setCommentsList', []);
        }
        if (this.documents.length) {
          this.$store.commit('requests/setDocumentsList', []);
        }
        this.$store.commit('requests/setRequestItemData', []);
      },
      openPrintModal() {
        this.$root.$emit('openPrintModal', this.printSettings);
      },
      openHistoryModal() {
        this.historySettings.title = this.requestData.request_order_nr;
        this.$root.$emit('openHistoryModal', this.historySettings);
      }
    },
    computed: {
      ...mapState('generic', ['incoterms', 'currentRoutePermissions']),
      ...mapState('woodware', ['delivery_methods']),
      ...mapState('partners', ['suppliers', 'customers', 'sellers']),
      ...mapState('requests', ['requestItemsColumns', 'requestItems', 'documents', 'comments', 'requestItemsPinnedRowData']),
      ...mapGetters('requests', {
        requestItemsGridOptions: 'requestItemsGridOptions'
      }),
      param() {
        return this.$route.params.id;
      },
      isNewRequest() {
        return this.param === 'new';
      },
      commonUrl() {
        return `purchase/request_orders/${this.param}/`;
      },
      requestLabel() {
        return this.isNewRequest ? `${this.$i18n.t('common_content.new')} ${this.$i18n.t('common_content.request')}` : `${this.$i18n.t('common_content.request')} / ${this.requestData.request_order_nr}`
      },
      requestInfo() {
        return this.isNewRequest ? '' : `${this.requestData.date_created} / ${this.$i18n.t('common_content.creator')}: ${this.requestData.created_by}`
      },
      historySettings() {
        return {url: `request_order/?id=${this.param}`, title: ``};
      },
      printSettings() {
        return {url: `purchase/request_orders/${this.param}/print/`, allowChanges: false, isHtmlReport: true};
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 540px)'} : {height: 'calc(100vh - 280px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 280px)'};
        }
      },
      RO_delivery_term() {
        return this.requestData.delivery_term;
      }
    },
    async beforeMount() {
      this.$store.dispatch('partners/getSellers');
      this.$store.dispatch('partners/getSuppliers');
      await this.$store.dispatch('generic/loadIncoterms');
      await this.$store.dispatch('woodware/getDeliveryMethods');
      await this.$store.dispatch('partners/getCustomers');
      if (this.isNewRequest) {
        this.requestData.incoterms = this.incoterms.find(e => e.id === 4);
        this.requestData.delivery_method = this.delivery_methods.find(e => e.id === 2);
        this.requestData.buyer = this.customers.find(e => e.id === 1458);
      }
      if (!this.isNewRequest) {
        this.getRequestinfo(this.param);
        this.$store.dispatch('requests/loadDocumentsList', {id: this.param});
        this.$store.dispatch('requests/loadCommentsList', {id: this.param});
      }
    },
    mounted() {
      this.$root.$on('updateRequestOrderInfo', (data) => {
        this.getRequestinfo(data.request_order.id);
      })
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/purchases/requests/Request.vue